import { SVGProps } from 'react';

const FileMusic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4M8 18v-7.7L16 9v7m-8 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m8-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default FileMusic;
